

























import { defineComponent } from "@vue/composition-api";
import { default as CompanyFooter } from "./company-footer.vue";
import { Translate, useLang } from "@lang";
import { AbsBox, Icon } from "@ui";

export default defineComponent({
	components:{
		CompanyFooter,
		Translate,
		AbsBox,
		Icon,
	},
	setup(_, ctx){
		
		const { translate } = useLang(ctx);

		return {
			translate,
		};
	}
});

